import React, { Component } from "react";
import { Box, Typography } from "@mui/material";
import Utils from "../../../provider/Utils";
// import { motion } from "framer-motion";
class SkinnyMeter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mercuryHeight: "0%", // Start at zero
    };
  }

  componentDidMount() {
    // Animate the mercury level after the component mounts
    const { goal, raised } = this.props;
    const percentage = Math.min((raised / goal) * 100, 100);
    setTimeout(() => {
      this.setState({ mercuryHeight: `${percentage}%` });
    }, 500);
  }

  componentDidUpdate(prevProps) {
    const { goal, raised } = this.props;
    if (prevProps.goal !== goal || prevProps.raised !== raised) {
      const percentage = Math.min((raised / goal) * 100, 100);

      this.setState({
        mercuryHeight: `${percentage}%`,
      });
    }
  }

  render() {
    const {
      goal,
      raised,
      color,
      isShowGoalAmount,
      measureType,
      is3dEffect,
      backgroundImage,
      meterFontColor,
    } = this.props;
    return (
      <>
        {/* Thermometer Cap */}
        <Box
          sx={{
            top: "4px",
            height: "35px",
            width: "53.8px",
            left: "18px",
            zIndex: "999",
            background: "#ddd",
            borderRadius: "50px 50px 0px 0px",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column-reverse",
            border: "10px solid #ccc",
            borderBottom: "none",
            transform: "rotateX(10deg)",
            transformStyle: "preserve-3d",
            perspective: "1000px",
            boxShadow: is3dEffect
              ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4), inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
              : "none",
          }}
        ></Box>
        <Box
          sx={{ textAlign: "center", position: "relative", height: "285px" }}
        >
          {isShowGoalAmount && (
            <Box
              sx={{
                position: "absolute",
                alignItems: "end",
                right: "80px",
                top: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "285px",
                color: backgroundImage !== null ? meterFontColor : "#353538",
                fontWeight: "400",
              }}
            >
              {measureType?.type === "% Meter" ? (
                <>
                  {[1, 0.8, 0.6, 0.4, 0.2, 0].map((value, index) => {
                    return (
                      <Typography
                        key={index}
                        variant="body2"
                        sx={{
                          visibility: value === 0 ? "hidden" : "visible",
                        }}
                      >
                        {`${(value * 100).toFixed(0)}%`}
                      </Typography>
                    );
                  })}
                </>
              ) : (
                <>
                  {[1, 0.8, 0.6, 0.4, 0.2, 0].map((value, index) => {
                    const amount = goal * value;
                    return (
                      <Typography
                        key={index}
                        variant="body2"
                        sx={{
                          visibility: amount === 0 ? "hidden" : "visible",
                        }}
                      >
                        ${Utils.formatCompactNumber(amount)}
                      </Typography>
                    );
                  })}
                </>
              )}
            </Box>
          )}
          <Box
            sx={{
              height: "285px",
              width: "54px",
              left: "18px",
              zIndex: "999",
              background: "#ddd",
              // borderRadius: "50px 50px 0px 0px",
              position: "relative",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column-reverse",
              border: "10px solid #ccc",
              borderBottom: "none",
              borderTop: "none",
              boxShadow: is3dEffect
                ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                : "none",
              clipPath: "polygon(0 0, 100% 0, 100% 98%, 50% 100%, 0 98%)",
              // boxShadow:
              //   "inset -4px 0 8px rgba(0, 0, 0, 0.4),inset 4px 0 8px rgba(0, 0, 0, 0.4),-4px 0 8px rgba(0, 0, 0, 0.6),4px 0 8px rgba(0, 0, 0, 0.4)",
            }}
          >
            {isShowGoalAmount && (
              <Box
                sx={{
                  position: "absolute",
                  left: "-15px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "285px",
                  color: "#fff",
                  fontWeight: "800",
                }}
              >
                {[...Array(50)].map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      position: "absolute",
                      bottom: `${index * 4}%`, // 5% interval
                      left: "10px",
                      width: index % 5 === 0 ? "16px" : "10px",
                      height: index % 5 === 0 ? "1px" : "0.5px",
                      background: "#000",
                      opacity: index % 5 === 0 ? 0.8 : 0.6,
                    }}
                  />
                ))}
              </Box>
            )}
            <Box
              sx={{
                width: "100%",
                background: color,
                transition: "height 1.5s ease-in-out",
                height: this.state.mercuryHeight,
                boxShadow: is3dEffect
                  ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                  : "none",
              }}
            />
          </Box>
          <Box
            sx={{
              width: "90px",
              height: "90px",
              background: color,
              borderRadius: "50%",
              border: "10px solid #ccc",
              position: "relative",
              top: "-18px",
              left: "50%",
              transform: "translateX(-50%)",
              boxShadow: is3dEffect
                ? "inset -4px 0 8px rgba(0, 0, 0, 0.4), inset 4px 0 8px rgba(0, 0, 0, 0.4)"
                : "none",
              // boxShadow: is3dEffect
              //   ? "inset -4px 0 8px rgba(0, 0, 0, 0.4), inset 4px 0 8px rgba(0, 0, 0, 0.4), -4px 0 8px rgba(0, 0, 0, 0.6), 4px 0 8px rgba(0, 0, 0, 0.4)"
              //   : "none",
              "&::before": {
                content: '""', // ✅ Required for ::before to show
                position: "absolute",
                top: "11%",
                left: "8%",
                width: "86%",
                height: "60%",
                background:
                  "radial-gradient(circle, rgba(255,255,255,0.7) 0%, transparent 90%)",
                clipPath: "ellipse(40% 40% at 40% 40%)",
                borderRadius: "50%",
                filter: "blur(1px)",
                transform: "rotate(-33deg)",
                zIndex: 2,
              },
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top:
                raised !== 0
                  ? `calc(${100 - parseFloat(this.state.mercuryHeight)}%)`
                  : `calc(${100 - parseFloat(this.state.mercuryHeight)
                  }% - 20px)`,
              left: "75px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              fontWeight: "bold",
              color: backgroundImage !== null ? meterFontColor : "#353538",
              fontSize: "18px",
              transform: "translateY(-50%)",
              transition: "top 1.5s ease-in-out",
            }}
          >
            <i
              className="fa fa-caret-left"
              aria-hidden="true"
              style={{ padding: "0 5px" }}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                color: backgroundImage !== null ? meterFontColor : "#353538",
              }}
            >
              <Typography variant="body2" className="fw-bold">
                Raised:
              </Typography>
              <Typography
                className="fw-bold text-start"
                variant="body2"
                fontWeight="bold"
                style={{ fontSize: "21px" }}
              >
                ${raised.toLocaleString()}
              </Typography>
            </Box>
          </Box>
        </Box>
      </>
    );
  }
}

export default SkinnyMeter;
